export default __webpack_public_path__ + "static/media/tokiOled@2x.8ea8ed75.png";